let runtimeI18n = null;

export function setRuntimeI18n(i18n) {
    runtimeI18n = i18n;
}

export function getRuntimeLocale() {
    return (
        runtimeI18n?.global?.locale?.value ||
        runtimeI18n?.global?.locale ||
        'en'
    );
}

export function translateRuntimeKey(key) {
    const translateFn = runtimeI18n?.global?.t;
    return typeof translateFn === 'function' ? translateFn(key) : key;
}
